import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "send-picker" }
const _hoisted_2 = {
  key: 0,
  class: "item-hint"
}
const _hoisted_3 = {
  class: "send-picker-kind",
  role: "radiogroup",
  "aria-label": "Send to"
}
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["value"]
const _hoisted_7 = ["value"]
const _hoisted_8 = {
  key: 2,
  class: "send-picker-row"
}
const _hoisted_9 = ["label"]
const _hoisted_10 = ["value"]
const _hoisted_11 = ["value"]
const _hoisted_12 = {
  key: 3,
  class: "send-picker-row"
}
const _hoisted_13 = ["value"]
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "item-hint" }
const _hoisted_16 = { class: "board-item-btns send-picker-btns" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.loaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Loading..."))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("label", {
              class: _normalizeClass(_ctx.kind == 'employee' ? 'active' : '')
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                value: "employee",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.kind) = $event))
              }, null, 512), [
                [_vModelRadio, _ctx.kind]
              ]),
              _cache[14] || (_cache[14] = _createTextVNode(" A person's tasks", -1))
            ], 2),
            _createElementVNode("label", {
              class: _normalizeClass(_ctx.kind == 'board' ? 'active' : '')
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                value: "board",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.kind) = $event)),
                disabled: !_ctx.decks.length || _ctx.isPrivate
              }, null, 8, _hoisted_4), [
                [_vModelRadio, _ctx.kind]
              ]),
              _cache[15] || (_cache[15] = _createTextVNode(" A deck", -1))
            ], 2),
            (_ctx.mirrorOn)
              ? (_openBlock(), _createElementBlock("label", {
                  key: 0,
                  class: _normalizeClass(_ctx.kind == 'meeting' ? 'active' : '')
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    value: "meeting",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.kind) = $event)),
                    disabled: !_ctx.availableMeetings.length
                  }, null, 8, _hoisted_5), [
                    [_vModelRadio, _ctx.kind]
                  ]),
                  _cache[16] || (_cache[16] = _createTextVNode(" A meeting", -1))
                ], 2))
              : _createCommentVNode("", true),
            (_ctx.inventory)
              ? (_openBlock(), _createElementBlock("label", {
                  key: 1,
                  class: _normalizeClass(_ctx.kind == 'inventory' ? 'active' : '')
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    value: "inventory",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.kind) = $event))
                  }, null, 512), [
                    [_vModelRadio, _ctx.kind]
                  ]),
                  _cache[17] || (_cache[17] = _createTextVNode(" Production Projects", -1))
                ], 2))
              : _createCommentVNode("", true)
          ]),
          (_ctx.kind == 'employee')
            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                key: 0,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.employeeID) = $event)),
                "aria-label": "Person"
              }, [
                _cache[18] || (_cache[18] = _createElementVNode("option", { value: null }, "Choose a person", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.people, (e) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: e.ID,
                    value: e.ID
                  }, _toDisplayString(e.Name), 9, _hoisted_6))
                }), 128))
              ], 512)), [
                [_vModelSelect, _ctx.employeeID]
              ])
            : (_ctx.kind == 'inventory')
              ? _withDirectives((_openBlock(), _createElementBlock("select", {
                  key: 1,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.inventoryLocation) = $event)),
                  "aria-label": "Location"
                }, [
                  _cache[19] || (_cache[19] = _createElementVNode("option", { value: null }, "Choose a location", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.INVENTORY_LOCATIONS, (l) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: l,
                      value: l
                    }, _toDisplayString(l), 9, _hoisted_7))
                  }), 128))
                ], 512)), [
                  [_vModelSelect, _ctx.inventoryLocation]
                ])
              : (_ctx.kind == 'meeting')
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.meetingID) = $event)),
                      "aria-label": "Meeting",
                      onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.meetingColumn = _ctx.selectedMeeting ? _ctx.selectedMeeting.Columns[0] : ''))
                    }, [
                      _cache[20] || (_cache[20] = _createElementVNode("option", { value: null }, "Choose a meeting", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.meetingGroups, (g) => {
                        return (_openBlock(), _createElementBlock("optgroup", {
                          key: g.label,
                          label: g.label
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(g.meetings, (m) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: m.ID,
                              value: m.ID
                            }, _toDisplayString(m.Name), 9, _hoisted_10))
                          }), 128))
                        ], 8, _hoisted_9))
                      }), 128))
                    ], 544), [
                      [_vModelSelect, _ctx.meetingID]
                    ]),
                    (_ctx.selectedMeeting)
                      ? _withDirectives((_openBlock(), _createElementBlock("select", {
                          key: 0,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.meetingColumn) = $event)),
                          "aria-label": "Column"
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedMeeting.Columns, (c) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: c,
                              value: c
                            }, _toDisplayString(c), 9, _hoisted_11))
                          }), 128))
                        ], 512)), [
                          [_vModelSelect, _ctx.meetingColumn]
                        ])
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.slug) = $event)),
                      "aria-label": "Deck",
                      onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.column = _ctx.selectedDeck ? _ctx.selectedDeck.Columns[0] : ''))
                    }, [
                      _cache[21] || (_cache[21] = _createElementVNode("option", { value: "" }, "Choose a deck", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableDecks, (d) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: d.Slug,
                          value: d.Slug
                        }, _toDisplayString(d.Name), 9, _hoisted_13))
                      }), 128))
                    ], 544), [
                      [_vModelSelect, _ctx.slug]
                    ]),
                    (_ctx.selectedDeck)
                      ? _withDirectives((_openBlock(), _createElementBlock("select", {
                          key: 0,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.column) = $event)),
                          "aria-label": "Column"
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedDeck.Columns, (c) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: c,
                              value: c
                            }, _toDisplayString(c), 9, _hoisted_14))
                          }), 128))
                        ], 512)), [
                          [_vModelSelect, _ctx.column]
                        ])
                      : _createCommentVNode("", true)
                  ])),
          _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.reminderHint), 1),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", {
              class: _normalizeClass(!_ctx.canSend || _ctx.busy ? 'disable-button' : '')
            }, [
              _createElementVNode("span", {
                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.send()))
              }, "Send")
            ], 2),
            _createElementVNode("div", null, [
              _createElementVNode("span", {
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$emit('cancel')))
              }, "Cancel")
            ])
          ])
        ], 64))
  ]))
}